import React, { Component } from "react";
import Typed from "typed.js";

import HomepageDreamJobs
    from "../../components/portfolio/Homepage/HomepageDreamJobs";
import HomepageGallery
    from "../../components/portfolio/Homepage/HomepageGallery";
import HomepageCooptation
    from "../../components/portfolio/Homepage/HomepageCooptation";
import HomepageTrust from "../../components/portfolio/Homepage/HomepageTrust";
import HomepageSpirit from "../../components/portfolio/Homepage/HomepageSpirit";
import HomepageGuide from "../../components/portfolio/Homepage/HomepageGuide";
import HomepageHeadhunt
    from "../../components/portfolio/Homepage/HomepageHeadhunt";
import HomepageExpertTeam
    from "../../components/portfolio/Homepage/HomepageExpertTeam";
import HomepageRecruit
    from "../../components/portfolio/Homepage/HomepageRecruit";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from '@fortawesome/pro-light-svg-icons';
import { FormattedMessage } from "react-intl";
import Picture from '../../components/Picture'
import MetaTags from '../../components/SEO/MetaTags'
import LocaleLink from '../../components/Routes/LocaleLink'


class HomePage extends Component
{
    parallax = React.createRef();

    componentDidMount () {
        const options = {
            strings: ["&nbsp;TECH", "&nbsp;IA", "&nbsp;DATA", "&nbsp;PRODUCT", "&nbsp;SOFTWARE", "&nbsp;CLOUD"],
            typeSpeed: 100,
            backSpeed: 50,
            backDelay: 2500,
            loop: true,
            loopCount: Infinity,
            cursorChar: '_',
        };
        this.typed = new Typed(this.el, options);
        this.typed.start();

        window.addEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY;
        const bannerDelta = scrollY / this.parallax.current.offsetHeight;
        this.parallax.current.style.bottom = Math.round(-180 * bannerDelta) + 'px'
    };

    componentWillUnmount () {
        window.removeEventListener('scroll', this.onScroll);
        this.typed.destroy()
    }

    jobs_ref = React.createRef();

    executeScroll = () => {
        this.jobs_ref.current.scrollIntoView({ behavior: 'smooth' })
    };

    render() {
        return (
            <div className="homepage">
                <MetaTags page="home" />

                <section className="banner text-center">
                    <div ref={this.parallax} className="banner-after"/>
                    <div className="container">
                        <div className="banner-img">
                            <Picture
                                src={require("../../../images/branding-urb.png")}
                                webp={require("../../../images/branding-urb.webp")} />
                            <Picture
                                className="blinking"
                                src={require("../../../images/branding-a.png")}
                                webp={require("../../../images/branding-a.webp")} />
                            <Picture
                                src={require("../../../images/branding-nlinker.png")}
                                webp={require("../../../images/branding-nlinker.webp")} />
                        </div>
                        <div className="banner-text">
                            <h1>
                                <FormattedMessage
                                    id="portfolio.homepage.experts"
                                    defaultMessage="Les experts du recrutement"
                                />
                                <span
                                    style={{whiteSpace: 'pre'}}
                                    ref={(el) => {this.el = el}}
                                />
                            </h1>
                            <LocaleLink to="/jobs" className="btn btn-line-danger">
                                <FormattedMessage
                                    id="wording.candidate"
                                    defaultMessage="Candidat"
                                />
                            </LocaleLink>
                            <LocaleLink to="/recruter-talent" className="btn btn-line-primary">
                                <FormattedMessage
                                    id="wording.recruiter"
                                    defaultMessage="Recruteur"
                                />
                            </LocaleLink>
                            <FontAwesomeIcon icon={faArrowDown} className="icon-arrow-down d-none d-md-block" onClick={this.executeScroll}/>
                        </div>
                    </div>
                </section>

                <HomepageHeadhunt/>

                <HomepageDreamJobs forwardedRef={this.jobs_ref}/>

                <HomepageExpertTeam/>

                <HomepageTrust/>

                <HomepageSpirit/>

                <HomepageGuide/>

                <HomepageGallery/>

                <HomepageRecruit />

                <HomepageCooptation/>
            </div>
        )
    }
}

export default HomePage;
